// @flow

import type { EasyAction } from "../../type";

import * as React from "react";

type Props = {
  convertId: string
};

window.dataLayer = window.dataLayer || [];

export default class Ocpc extends React.PureComponent<Props> {
  static actions: EasyAction[] = [
    {
      title: "记录注册事件",
      name: "pushEvent"
    }
  ];

  componentWillMount() {
    loadAdCode();
  }

  actionPushEvent = (data: void) => {
    // $FlowFixMe
    window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
  };

  render() {
    return null;
  }
}

function loadAdCode() {
  /* eslint-disable */
  window._agl = window._agl || [];
  (function() {
    window._agl.push(["production", "_f7L2XwGXjyszb4d1e2oxPybgD"]);
    (function() {
      var agl = document.createElement("script");
      agl.type = "text/javascript";
      agl.async = true;
      agl.src =
        "https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD";
      var s:any = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(agl, s);
    })();
  })();
  /* eslint-enable */
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/plugin/Ocpc.js